import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ArrowRight } from "lucide-react";
import GleverLogo from "@/components/GleverLogo";

export function LandingNav() {
  const { user } = useAuth();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[hsl(222_47%_5%)]/80 backdrop-blur-lg border-b border-white/[0.06]">
      <div className="mx-auto px-5 sm:px-8 md:px-10 py-3.5 flex items-center justify-between max-w-[1280px]">
        <div className="flex items-center gap-10">
          <Link to="/" className="flex items-center gap-2.5">
            <GleverLogo className="h-5 w-auto" alt="Growth Lever" />
          </Link>
          <div className="hidden md:flex items-center gap-8 text-sm text-white/70">
            <a href="/#pricing" onClick={(e) => { const el = document.getElementById('pricing'); if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth' }); } }} className="hover:text-white transition-colors cursor-pointer">Pricing</a>
            <Link to="/help" className="hover:text-white transition-colors">Help</Link>
          </div>
        </div>
        <div className="flex items-center gap-3">
          {user ? (
            <Link
              to="/dashboard"
              className="flex items-center gap-1.5 text-sm font-medium text-black bg-white px-5 py-2 rounded-full hover:bg-white/90 transition-colors"
            >
              Dashboard <ArrowRight className="h-3.5 w-3.5" />
            </Link>
          ) : (
            <>
              <Link to="/auth" className="text-sm text-white/50 hover:text-white transition-colors hidden sm:block">
                Log in
              </Link>
              <Link
                to="/contact"
                className="text-sm font-semibold text-white bg-[hsl(217_91%_60%)] px-5 py-2 rounded-full hover:bg-[hsl(217_91%_65%)] transition-colors"
              >
                Get a Demo
              </Link>
              <Link
                to="/auth?tab=signup"
                className="text-sm font-semibold text-black bg-white px-5 py-2 rounded-full hover:bg-white/90 transition-colors"
              >
                Start free
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
